// removed by extract-text-webpack-plugin
module.exports = {"checkbox-name":"MobileQuestion__checkbox-name___1A9wP","question":"MobileQuestion__question___awg3m","question-checkbox":"MobileQuestion__question-checkbox___gmveU"};